import React from "react";
import styled from "styled-components";

export default styled.div`
    > .button-wrapper {
        text-align: center;
    }
    h3 {
        text-align: center;
        color: rgb(85 98 192);
        font-weight: 700;
        font-size: 40px;
    }

`;